export const getRandomNumber = () => {
  return Math.floor(Math.random() * 10)
}

export default function getUserRandomName(city = "") {
  const randomNumArr = new Array(8).fill(0).map(() => getRandomNumber())
  return `南方+${city}网友${randomNumArr.join("")}`
}
